<div class="chips-list">

    <mat-chip-list>
        <ng-container *ngFor="let chipValue of definedChipsValues">
            <mat-chip
                        class="chip"
                        (removed)="remove(chipValue.key)">
                <app-chip-value [config]="getChipConfig(chipValue.key)"
                                [value]="chipValue">
                </app-chip-value>
            </mat-chip>
            <div *ngIf="shouldInsertBreak(chipValue.key)" class="chips-list__break"></div>
        </ng-container>
    </mat-chip-list>

</div>
